import FlexPane from './_flex-pane.js'
import ScrollPane from './_scroll-pane.js'
import Betslip from './_betslip.js'
import BetBuilder from './_bet-builder.js'
import BetReceipt from './_bet-receipt.js'

export default {
  name: 'BetslipView',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          height: '100%',
          width: '100%',
        },
      },
    },
    scrollPane: {
      configSet: ScrollPane,
      configValues: {
        direction: 'y',
      },
    },
    betslip: {
      configSet: Betslip,
      configValues: {},
    },
    betBuilder: {
      configSet: BetBuilder,
      configValues: {},
    },
    betReceipt: {
      configSet: BetReceipt,
      configValues: {
        view: {
          container: {
            style: {
              _mobile_minHeight: '100%',
            },
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
